<h4>What this screen is for</h4>
<p>
    Reference documentation for FareVantage's public API, generated from the API
    itself, so it always describes the version you are actually talking to. It is aimed
    at whoever is integrating with FareVantage rather than at day-to-day pricing work.
</p>

<h4>Using it</h4>
<ul>
    <li>
        Every endpoint expands to show its parameters, the shape of the request and the
        responses it can return, with an example of each.
    </li>
    <li>
        <strong>Try it out</strong> calls the real API as you, using the session you are
        already signed in with. There is no separate key to paste in and no sandbox.
    </li>
    <li>
        The filter sidebar and the date filters are hidden here &mdash; nothing on this
        screen is driven by them.
    </li>
</ul>

<h4>Worth knowing</h4>
<ul>
    <li>
        <strong>Try it out is not a rehearsal.</strong> A request that writes, writes for
        real, against the environment you are signed in to. Read the endpoint before
        sending it.
    </li>
    <li>
        This is the <strong>public</strong> API only. The endpoints the FareVantage
        screens themselves use are not documented here.
    </li>
    <li>
        If the page reports that it could not load the documentation, refresh it; the
        spec is fetched once when the screen opens.
    </li>
</ul>
